const baasicSystemRoles = {
    administratorRoleName: "Administrators",
    userRoleName: "Users",
    accountOwnerRoleName: "AccountOwner",
    anonymousRoleName: "Anonymous",
};

export default baasicSystemRoles;
